import React from "react";
import "./styles.css";
import { Card, Col, Row } from "antd";
// import administrator from "../../../Images/administrator.png";

export default class MedTable extends React.Component {
  state = {
    totalCourses: 0,
    totalUsers: 0,
    usersLoading: true,
    coursesLoading: true,
  };

  componentDidMount = () => {
    fetch("https://sbhs-web-server.herokuapp.com/lte/user/all")
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          this.setState({
            totalUsers: response.length,
            usersLoading: false,
          });
        }
      });

    fetch("https://sbhs-web-server.herokuapp.com/lte/course/all")
      .then((response) => response.json())
      .then((response) => {
        if (response) {
          this.setState({
            totalCourses: response.length,
            coursesLoading: false,
          });
        }
      });
  };

  render() {
    return (
      <div>
        <Row gutter={[16, 16]}>
          <Col span="12">
            {" "}
            {this.state.usersLoading ? (
              <Card
                className="statusCard"
                loading={this.state.usersLoading}
              ></Card>
            ) : (
              <div className="userStats">
                <h2 style={{ color: "#ffffff" }}>Total Users</h2>
                <p style={{ color: "#ffffff" }}>{this.state.totalUsers}</p>
              </div>
            )}
          </Col>
          <Col span="12">
            {this.state.coursesLoading ? (
              <Card
                className="statusCard"
                loading={this.state.coursesLoading}
              ></Card>
            ) : (
              <div className="userStats">
                <h2 style={{ color: "#ffffff" }}>Total Courses</h2>
                <p style={{ color: "#ffffff" }}>{this.state.totalCourses}</p>
              </div>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}
